import { render } from "./capa.vue?vue&type=template&id=3503d175"
import script from "./capa.vue?vue&type=script&lang=js"
export * from "./capa.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__